import { render, staticRenderFns } from "./AddSellerForm.vue?vue&type=template&id=6747b8e0&scoped=true&"
import script from "./AddSellerForm.vue?vue&type=script&lang=js&"
export * from "./AddSellerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6747b8e0",
  null
  
)

export default component.exports